<script>
export default {
    props: {
        houseSlug: {
            type: String,
            required: true
        },
        isDefault: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        async toggleDefault() {
            try {
                await axios.post(route("owner.houses.setDefault", this.houseSlug));
                window.location.reload();
            } catch (e) {
                console.log(e);
                this.$swal('Error!', 'Something went wrong while setting default house.', 'error');
            }
        }
    }
}
</script>
